import styled from 'styled-components';
import { spaceOptions } from './utils';

export const Icon = styled.img`
  width: ${props => `${props.width}px` || `25px`};
  height: ${props => `${props.height}px` || `25px`};
  margin-right: 15px;
  display: inline-block;
  vertical-align: middle;
  ${spaceOptions};
`;

Icon.display = 'Icon';
